import React from "react";
import PropTypes from "prop-types";
import ReactSlider from "react-slider";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Slider extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string,
		label: PropTypes.string,
		value: PropTypes.any.isRequired,
		min: PropTypes.any.isRequired,
		max: PropTypes.any.isRequired,
		step: PropTypes.number.isRequired,
		stepValues: PropTypes.array,
		disabled: PropTypes.bool.isRequired,
		shouldFormatInputValue: PropTypes.bool.isRequired,
		valueFormatter: PropTypes.func,
		onChange: PropTypes.func,
	};

	static defaultProps = {
		min: 0,
		max: 100,
		step: 1,
		disabled: false,
		shouldFormatInputValue: false
	};

	componentDidUpdate(prevProps) {
		const {props} = this;

		if (prevProps.min !== props.min || prevProps.max !== props.max) {
			const {min, max, onChange} = props;

			if (onChange) {
				const value = props.value !== null ? props.value : min;
				const newValue = Math.min(Math.max(value, min), max);
				onChange(newValue);
			}
		}
	}

	render() {
		const {props} = this;
		const {disabled, name, label, min, max, step, stepValues, valueFormatter, shouldFormatInputValue, onChange, unit} = props;
		let {showValues} = props;
		const value = !disabled ? props.value || min : min;
		const classes = createClassName(props.className, {
			"Slider": true,
			"disabled": disabled,
		});

		if (showValues === undefined) {
			showValues = true;
		}

		return (
			<div className={classes}>
				<div className="Slider-top">
					{!!label && <div className="Slider-label">{label}</div>}
					{!!showValues &&
					<div
						className="Slider-value">{(valueFormatter ? valueFormatter(value) : value) + (unit || "")}</div>
					}
				</div>

				<div className="Slider-container">

					{!!showValues &&
					<div className="Slider-step-value min">{stepValues ? stepValues[0] : min}</div>
					}

					<ReactSlider
						className="Slider-slider"
						handleClassName="Slider-slider-handle"
						barClassName="Slider-slider-bar"
						value={!disabled ? value : min}
						min={min}
						max={max}
						step={step}
						disabled={disabled}
						onChange={!disabled ? onChange : undefined}
						withBars
					/>

					{!!showValues &&
					<div className="Slider-step-value max">{stepValues ? stepValues[1] : max}</div>
					}
				</div>

				{!!name && (
					<input
						type="hidden"
						name={name}
						value={shouldFormatInputValue && valueFormatter ? valueFormatter(value) : value}
						disabled={disabled}
					/>
				)}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js